/**
 * 提交路由信息
 * 
 * @param param0 
 * @param data 
 */
export const commitDynamicRouterData = ({ commit, state }: { commit: any, state: any }, menuItems: any) => {
  commit('addDynamicRouter', menuItems)
}
